<template lang='pug'>
  .video-demo
    yet-another-arch
    v-row(justify='center' align='center')
      v-col(cols='10' lg='6')
        wistia-video.elevation-8.mb-10.mt-10
</template>

<script>
import YetAnotherArch from './YetAnotherArch';
import WistiaVideo from './WistiaVideo';

export default {
  name: 'VideoDemo',
  components: {WistiaVideo, YetAnotherArch}
};
</script>

<style scoped lang='scss'>
  .video-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;

    iframe {
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      position: absolute;
    }
  }

  .video-demo {
    background: linear-gradient(180deg, #ECEFF1, #FFFFFF);
  }
</style>
